import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import './Metric.css';
import i18n from '../../../i18n';
import './tooltip.css';

library.add(faQuestionCircle);

class Metric extends Component {

  render() {
    const {
      displayName,
      description,
      values,
      tooltips,
      append,
      bold,
      hideLine
    } = this.props;


    let match = Math.max(...values.filter((val) => { return val !== null; }));
    if (bold === 'min') {
      match = Math.min(...values.filter((val) => { return val !== null; }));
    }

    const columns = values.map((value, idx) => {
      if (!value) {
        return (<td key={idx} className='textCenter'>-</td>);
      } else {
        let valueClass = 'textCenter';
        if (Number(value) === match) {
          valueClass = 'textCenterBold';
        }
        return (
          <td key={idx} className={valueClass}>
            {value}{append}
            {tooltips &&
              <React.Fragment>
                <FontAwesomeIcon style={{ marginLeft: '2px', cursor: 'pointer' }} data-tip data-for={'feesn' + idx} icon="question-circle" size="sm" />
                <ReactTooltip id={'feesn' + idx} type='light' className="feetipn" effect="float">
                  <div dangerouslySetInnerHTML={{ __html: tooltips[idx] }} />
                </ReactTooltip>
              </React.Fragment>
            }
          </td>
        );
      }
    });

    return (
      <tbody className={hideLine ? 'noLine' : ''} style={{ 'borderTop': '0px' }}>
        <tr>
          <td className='textLeft'>
            <div style={{ fontWeight: 'bold' }}>{i18n.t(displayName)}</div>
          </td>
          <td className='textLeft'>
            <div>{i18n.t(description)}</div>
          </td>
          {columns}
        </tr>
      </tbody>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: state.fundData.data,
  };
}

export default connect(mapStateToProps, {
})(Metric);

